function exchangeInit() {
  const currencyUrl = "https://ziar-api.myterranet.com/api/reader/currency-rates";
  fetch(currencyUrl, {
    headers: {
      Accept: "application/json", "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (res) {
      renderCurrencyPageByData(res.data, res?.meta);
    }).catch(e => {
      console.error('Not response from currency server.')
  });

  const currencyPageOptions = {
    columns: ["EUR", "USD", "RON"],
    defaultCourseByBankId: "bnm",
    defaultCurrencyChange: "EUR",
    defaultCurrencyValue: 100,
  };

  let bnmCoursers = {};
  let exchange = {};
  let exchangeCourse = 0;
  const toExchangeInput = document.getElementsByName("to_exchange")[0];
  const fromExchangeInput = document.getElementsByName("from_exchange")[0];
  const fromExchangeSelect = document.getElementsByClassName("gh-select-currency-from")[0];
  const toExchangeSelect = document.getElementsByClassName("gh-select-currency-to")[0];
  const fromExchangeLabel = document.getElementsByClassName("js-from-exchange-label")[0];
  const toExchangeLabel = document.getElementsByClassName("js-to-exchange-label")[0];
  const mobileCurrencyList = document.getElementsByClassName('gh-mobile-select-currency')[0];

  initEventExchangePanel();

  window.addEventListener('click', function (e) {


    if (e.target.closest('.gh-cm-dropdown-element')) {
      const currencyChar = e.target.getAttribute('data-id');
      const currencyRate = e.target.getAttribute('data-rate');
      const selectedContainer = e.target
        .closest('.gh-select-currency')
        .getElementsByClassName('gh-cm-button')[0];

      selectedContainer.innerHTML = currencyChar;
      selectedContainer.setAttribute('data-rate', currencyRate);
      fromExchangeInput.dispatchEvent(new Event("input"));
    }

    if (e.target.closest('.gh-exchange-currency-flip')) {
      const fromExchangeLabelTemp = fromExchangeLabel.innerText;
      const fromExchangeRate = fromExchangeLabel.getAttribute('data-rate');

      const toExchangeLabelTemp = toExchangeLabel.innerText;
      const toExchangeRate = toExchangeLabel.getAttribute('data-rate');

      fromExchangeLabel.innerText = toExchangeLabelTemp;
      fromExchangeLabel.setAttribute('data-rate', toExchangeRate);

      toExchangeLabel.innerText = fromExchangeLabelTemp;
      toExchangeLabel.setAttribute('data-rate', fromExchangeRate);

      fromExchangeInput.dispatchEvent(new Event("input"));
    }

    if (e.target.closest('.js-select-currency-mob')) {
      const currencySelected = e.target.getAttribute('data-id');
      const currencyLabel = e.target.closest('.gh-dropdown-box').getElementsByClassName('js-column-exchange-label')[0];
      currencyLabel.innerText = currencySelected;

      const dropDownToggle = document.querySelectorAll(".gh-currencies-label.active, .gh-currencies-values.active");
      dropDownToggle.forEach(elClass => {
        elClass.classList.remove('active')
      })

      const dropUpToggle = document.querySelectorAll('.gh-currencies-values[data-id="' + currencySelected + '"],' + '.gh-currencies-label[data-id="' + currencySelected + '"]');
      dropUpToggle.forEach(elClass => {
        elClass.classList.add('active')
      })
    }
  });

  function initEventExchangePanel() {
    toExchangeInput.addEventListener("input", (event) => {
      currencyExchangeEvent(event.target.value, "foreign");
    });

    fromExchangeInput.addEventListener("input", (event) => {
      currencyExchangeEvent(event.target.value);
    });
  }

  function currencyExchangeEvent(from, side = "default") {
    exchangeCourse = fromExchangeLabel.getAttribute('data-rate') / toExchangeLabel.getAttribute('data-rate');

    if (side === "default") {
      const calc = parseFloat(from) * parseFloat(exchangeCourse);
      toExchangeInput.value = calc.toFixed(2);
    } else {
      const calc = parseFloat(from) / parseFloat(exchangeCourse);
      fromExchangeInput.value = calc.toFixed(2);
    }
  }

  function renderCurrencyPageByData(data, meta) {
    const currencyRowContainer = document.getElementsByClassName("gh-currencies-list")[0];
    let currencyInfo = {};
    if (meta?.currencies) {
      meta.currencies.map(elMeta => {
        currencyInfo[elMeta.char_code] = elMeta;
      })
    }

    const dateContainer = document.querySelector('.js-data-select');
    dateContainer.innerText = new Date(meta.date).toLocaleDateString("ro-RO");
    exchange = data.find((el) => el.id === currencyPageOptions.defaultCourseByBankId);

    if (!(exchange?.currencies)) {
      return;
    }

    fillableCurrencyOptions(exchange.currencies, currencyInfo);

    bnmCoursers = exchange.currencies
      .find((el) => el?.char_code === currencyPageOptions.defaultCurrencyChange);

    exchangeCourse = exchange.currencies
      .find((el) => el.char_code === currencyPageOptions.defaultCurrencyChange)
      ?.value.toFixed(2) || 0;

    fromExchangeInput.value = currencyPageOptions.defaultCurrencyValue;
    fromExchangeLabel.innerText = bnmCoursers.char_code;
    fromExchangeLabel.setAttribute('data-rate', bnmCoursers.value);
    fromExchangeInput.dispatchEvent(new Event("input"));

    currencyRowContainer.innerHTML = renderCurrencyPanelHeader();
    currencyRowContainer.innerHTML += data
      .map((el) => {
        return renderCurrencyPanelRow(el);
      })
      .join(" ");

    mobileCurrencyList.innerHTML = renderCurrencyMobileLi(currencyInfo);
  }

  function renderCurrencyMobileLi(meta) {
    return currencyPageOptions.columns
      .map((el, key) => {
        const currencyInfo = (typeof meta[el]['name_ro'] !== undefined ? ' - ' + meta[el]['name_ro'] : '');

        return `<li class="gh-cm-element js-select-currency-mob" data-id="${el}">${el} ${currencyInfo}</li>`;
      })
      .join(" ");
  }

  function fillableCurrencyOptions(options = [], meta = []) {
    options.map((el) => {
      const currencyInfo = (typeof meta[el.char_code]['name_ro'] !== undefined ? ' - ' + meta[el?.char_code]['name_ro'] : '');
      const elementItem = `<li class="gh-cm-dropdown-element" data-id="${el.char_code}" data-rate="${el.value}">
        ${el.char_code} ${currencyInfo}
      </li>`;
      fromExchangeSelect.innerHTML += elementItem;
      toExchangeSelect.innerHTML += elementItem;
    });
  }

  function renderCurrencyPanelHeader() {
    return `<div class="gh-currencies-list-row gh-currencies-list-title"><div></div>
      ${currencyPageOptions.columns
      .map((el, key) => {
        return `
        <div data-id="${el}" class="gh-currencies-label ${(key === 0) ? 'active' : ''}">
          <strong>${el}</strong>
          <div class="gh-currencies-values">
            <span>Cump</span>
            <span>Vanz</span>
          </div>
        </div>`;
      })
      .join(" ")}
    </div>`;
  }

  function renderCurrencyPanelRow(row) {
    if (row.id === currencyPageOptions.defaultCourseByBankId) return;

    return `<div id=${row.id} class="gh-currencies-list-row">
      <div class="gh-currency-name"> ${row.name} </div>
        ${currencyPageOptions.columns.map((el, key) => {

      const currencyRow = row.currencies.find((element) => element.char_code === el);

      return `<div data-id="${el}" class="gh-currencies-values ${(key === 0) ? 'active' : ''}">
                <span>${currencyRow?.buy.toFixed(2) || " - "}</span>
                <span>${currencyRow?.sell.toFixed(2) || " - "}</span>
              </div>`;
    })
      .join(" ")}
      </div>`;
  }
}
